import { JobData } from "./careers.model";
import { Component, OnInit } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { Urls } from "@root/utils/urls";
import { ApiService } from "@shared/services/api.service";
import { MatDialog } from "@angular/material/dialog";
import { ApplyJobDialogComponent } from "@component/careers/apply-job-dialog/apply-job-dialog.component";
import { SearchFilterPipe} from '@common/pipe/search-filter.pipe';
import {environment} from '../../../environments/environment.prod'

@Component({
  selector: "app-careers",
  templateUrl: "./careers.component.html",
  styleUrls: ["./careers.component.scss"],
})
export class CareersComponent implements OnInit {
  
  jobData = new JobData();

  departmentList = [];

  locationList = [];

  postedJobList = [];

  panelMap: { [key: string]: boolean } = {};

  pageUrl: string;

  public searchText: string;

  constructor(
    public apiService: ApiService,
    private toastr: ToastrService,
    public dialog: MatDialog
  ) {}

  ngOnInit() {
    this.scrollTop();
    this.readDepartment();
    this.readLocation();
    this.searchJob();
    this.pageUrl = location.href;
  }

  scrollTop = () => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };

  investOnline = () => {
      if(!environment.isDRBuild){
        window.open("https://investonline.itiamc.com/", "_blank");
      }else{
        window.open("https://drinvestor.itiamc.com/", "_blank"); //DR-inv
      }
    };

  public readDepartment() {
    this.apiService.getData(Urls.getCareersDeparment).subscribe(
      (response) => {
        this.departmentList = response.data.departments;
      },
      (error) => {
        this.toastr.error(error.errorMessage);
      }
    );
  }

  public readLocation() {
    this.apiService.getData(Urls.getCareersLocation).subscribe(
      (response) => {
        this.locationList = response.data.locations;
      },
      (error) => {
        this.toastr.error(error.errorMessage);
      }
    );
  }

  public searchJob() {
    const searchPipe = new SearchFilterPipe();
    this.apiService.postData(Urls.getCareersJOB, this.jobData).subscribe(
      (response) => {
        if (response.status === 0) {
          const postedJobList = response.data.careerJobs;
          this.postedJobList = searchPipe.transform(postedJobList, ['jobPostion', 'skills'], this.searchText) ;
        } else {
          this.postedJobList = [];
        }
      },
      (error) => {
        this.postedJobList = [];
      }
    );
  }

  public openApplyJobDialog() {
    const dialogRef = this.dialog.open(ApplyJobDialogComponent,{
      width: "90%",
    });
  }

  keyPress(event: any) {
    const pattern = /[a-zA-Z ]/;

    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
}
